/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Meta_DescInputs */

const en_pc_dl_meta_desc = /** @type {(inputs: Pc_Dl_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft download links for Windows, macOS, Linux, FreeBSD and the web, with step-by-step install instructions and SHA256 checksum verification.`)
};

const zh_pc_dl_meta_desc = /** @type {(inputs: Pc_Dl_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 下载链接（Windows、macOS、Linux、FreeBSD 与网页版），附逐步安装说明与 SHA256 校验方法。`)
};

/**
* | output |
* | --- |
* | "PdfCraft download links for Windows, macOS, Linux, FreeBSD and the web, with step-by-step install instructions and SHA256 checksum verification." |
*
* @param {Pc_Dl_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_meta_desc = /** @type {((inputs?: Pc_Dl_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_meta_desc(inputs)
	return zh_pc_dl_meta_desc(inputs)
});
export { pc_dl_meta_desc as "pc.dl.meta_desc" }